import { trendingTopics } from '@/mocks/home';

export default function TrendingTopics() {
  return (
    <section className="py-14 md:py-20">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950 mb-3">
            热门话题
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-lg mx-auto">
            大家都在关注这些时髦话题，赶快加入讨论吧
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3 md:gap-4">
          {trendingTopics.map((topic) => (
            <a
              key={topic.id}
              href="#"
              className="flex items-center justify-between bg-background-50 rounded-xl p-4 md:p-5 border border-background-200/70 hover:border-primary-300 hover:bg-primary-50/50 transition-all duration-300 group cursor-pointer"
            >
              <span className="text-sm md:text-base font-medium text-foreground-800 group-hover:text-primary-600 transition-colors whitespace-nowrap">
                {topic.title}
              </span>
              <span className="text-xs text-foreground-400 bg-background-100 px-2 py-1 rounded-full whitespace-nowrap">
                {topic.count}
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}